/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default function(
	CustomElement,
	{ events = {}, mapAttributes = () => ({}), mapProperties = () => ({}), onRender, onUnmount }
) {
	let tagName;
	const getTagName = () => tagName || (tagName = new CustomElement().tagName);

	function isNativeEvent(eventName) {
		return (
			eventName.indexOf('on') === 0 &&
			eventName[2] === eventName[2].toUpperCase() &&
			!events[eventName]
		);
	}

	class Comp extends React.Component {
		static propTypes = {
			...Object.keys(events).reduce((types, name) => {
				types[name] = PropTypes.func;

				return types;
			}, {}),
		};

		static get displayName() {
			return getTagName();
		}

		componentDidMount() {
			this.componentWillReceiveProps(this.props, {});
		}

		componentWillReceiveProps(props, prevProps) {
			const node = ReactDOM.findDOMNode(this);

			const properties = mapProperties(props);

			Object.keys(props).forEach(name => {
				if (props[name] !== prevProps[name]) {
					if (events[name]) {
						if (prevProps[name]) {
							node.removeEventListener(events[name], prevProps[name]);
						}

						node.addEventListener(events[name], props[name]);
					} else if (properties[name]) {
						node[name] = props[name];
					}
				}
			});

			onRender && onRender.call(this, node, props);
		}

		componentWillUnmount() {
			const node = ReactDOM.findDOMNode(this);
			Object.keys(events).forEach(name => {
				node.removeEventListener(events[name], this.props[name]);
			});

			onUnmount && onUnmount.call(this, node, this.props);
		}

		render() {
			const props = mapAttributes(this.props);

			// Pass down native react events (eg. onClick) so that they can be handled
			// by reacts syntethic events system
			Object.keys(this.props).forEach(name => {
				if (isNativeEvent(name)) {
					props[name] = this.props[name];
				}
			});

			return React.createElement(getTagName(), props);
		}
	}

	return Comp;
}
